import {BonusStatus, BonusTabType} from '@/stores/BonusesStore/BonusesStore.constants';
import {BonusesState, IBonusData} from '@/stores/BonusesStore/BonusesStore.types';

import {Store} from '@/stores/Store';

const initialBonusesState: BonusesState = {
  activeTab: BonusTabType.UserBonuses,
  bonuses: [],
  unwatchedBonusIds: [],
};

export class BonusesStore extends Store<BonusesState> {
  constructor() {
    super(initialBonusesState);
  }

  public setBonuses(bonuses: IBonusData[], unwatchedBonusIds: string[]): void {
    this.setState({
      ...initialBonusesState,
      unwatchedBonusIds,
      bonuses,
    });
  }

  public getBonuses = (): IBonusData[] => {
    return this.getState().bonuses;
  };

  public hasUnwatchedBonusIds = (): boolean => {
    return this.getState().unwatchedBonusIds.length !== 0;
  };

  public isBonusUnwatched = (bonusId: string): boolean => {
    return Boolean(this.getState().unwatchedBonusIds.find((unwatchedBonusId) => unwatchedBonusId === bonusId));
  };

  public addUnwatchedBonus = (bonusId: string): void => {
    const currentUnwatchedBonuses = this.getState().unwatchedBonusIds;
    const newUnwatchedBonuses = [...currentUnwatchedBonuses, bonusId];
    this.setBonusesState({unwatchedBonusIds: newUnwatchedBonuses});
  };

  public deleteWatchedBonus = (bonusId: string): void => {
    const currentUnwatchedBonuses = this.getState().unwatchedBonusIds;
    const newUnwatchedBonuses = currentUnwatchedBonuses.filter((unwatchedBonusId) => unwatchedBonusId !== bonusId);
    this.setBonusesState({unwatchedBonusIds: newUnwatchedBonuses});
  };

  public getBonusById = (bonusId: string | null): IBonusData | undefined => {
    return this.getBonuses().find((bonus) => bonus.id === bonusId);
  };

  public setActiveTabBonuses = (): void => {
    this.setBonusesState({activeTab: BonusTabType.Bonuses});
  };

  public setActiveTabUserBonuses = (): void => {
    this.setBonusesState({activeTab: BonusTabType.UserBonuses});
  };

  public isActiveTabBonuses = (): boolean => {
    return this.getState().activeTab === BonusTabType.Bonuses;
  };

  public isActiveTabUserBonuses = (): boolean => {
    return this.getState().activeTab === BonusTabType.UserBonuses;
  };

  public isUserBonusStatusPending = (status: BonusStatus): boolean => {
    return status === BonusStatus.Pending;
  };

  private setBonusesState = (partialState: Partial<BonusesState>): void => {
    const state = this.getState();

    this.setState({
      ...state,
      ...partialState,
    });
  };
}
